import { RouteType } from "types/RouteType";

const BatchPlantVisualizerRoute: RouteType = {
  name: "Batch Plant Visualizer",
  path: "/batch-plant/visualizer",
  layout: "/app",
  group: "Batch Plant",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Batch Plant 3D Visualizer",
      component: () => import("./BatchPlantVisualizer.Header"),
      enableRefreshButton: false,
      enableBackButton: true,
      color: "primary",
    },
    body: {
      component: () => import("./BatchPlantVisualizer.Body"),
      grayBackground: false,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Initialize the visualizer view store
      const viewStore = (rootStore as any).batchPlantVisualizerViewStore;
      if (viewStore) {
        viewStore.reset();
      }

      // Optionally load real data from service stores
      const promises = [];

      const trucksStore = (rootStore as any).trucksStore;
      if (trucksStore) {
        promises.push(trucksStore.find({ query: { $limit: 50 } }));
      }

      const materialsStore = (rootStore as any).materialsStore;
      if (materialsStore) {
        promises.push(materialsStore.find({ query: { $limit: 100 } }));
      }

      const mixDesignsStore = (rootStore as any).mixDesignsStore;
      if (mixDesignsStore) {
        promises.push(mixDesignsStore.find({ query: { $limit: 100 } }));
      }

      await Promise.all(promises);

      return true;
    } catch (error) {
      console.error("Failed to load batch plant visualizer data:", error);
      return true; // Allow navigation even if data loading fails
    }
  },
  onExit: ({ rootStore }) => {
    const viewStore = (rootStore as any).batchPlantVisualizerViewStore;
    if (viewStore) {
      viewStore.reset();
    }
  },
};

export default BatchPlantVisualizerRoute;
